import { render, staticRenderFns } from "./FlagAsInappropiate.vue?vue&type=template&id=6c5cd1e2&scoped=true"
import script from "./FlagAsInappropiate.vue?vue&type=script&lang=js"
export * from "./FlagAsInappropiate.vue?vue&type=script&lang=js"
import style0 from "./FlagAsInappropiate.vue?vue&type=style&index=0&id=6c5cd1e2&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5cd1e2",
  null
  
)

export default component.exports